import { alertModal } from '@/stores/alertModal';

export const POSITION = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
};

export function useToast() {
  return alertModal;
}

export default {
  install(app) {
    app.config.globalProperties.$toast = alertModal;
    app.provide('toast', alertModal);
  },
};
